/**
 * statusCodes.ts
 * 협력사/라이더 상태 코드 상수 정의
 *
 * @description
 * - 협력사 운영 상태 (운영중, 대기중, 일시중지, 운영중지요청, 운영종료)
 * - 라이더 계약 상태 (계약중, 계약종료, 계약대기)
 * - 코드 ↔ 라벨 매핑
 * - 셀렉트박스 옵션
 */

// ============================================================
// 협력사 운영 상태
// ============================================================
export const SUPPLIER_STATUS = {
    OPERATING: 'OPERATING',
    READY: 'READY',
    SUSPENDED: 'SUSPENDED',
    TERMINATION_REQUESTED: 'TERMINATION_REQUESTED',
    TERMINATED: 'TERMINATED',
} as const;

export type SupplierStatus = typeof SUPPLIER_STATUS[keyof typeof SUPPLIER_STATUS];

// 협력사 운영 상태 라벨 매핑
export const SUPPLIER_STATUS_LABELS: Record<SupplierStatus, string> = {
    [SUPPLIER_STATUS.OPERATING]: '운영중',
    [SUPPLIER_STATUS.READY]: '준비중',
    [SUPPLIER_STATUS.SUSPENDED]: '운영중지',
    [SUPPLIER_STATUS.TERMINATION_REQUESTED]: '계약종료 접수',
    [SUPPLIER_STATUS.TERMINATED]: '계약종료',
};

// 협력사 상태 정렬 순서 (공지사항 등에서 사용)
export const SUPPLIER_STATUS_ORDER: Record<SupplierStatus, number> = {
    [SUPPLIER_STATUS.OPERATING]: 1,
    [SUPPLIER_STATUS.TERMINATION_REQUESTED]: 2,
    [SUPPLIER_STATUS.READY]: 3,
    [SUPPLIER_STATUS.SUSPENDED]: 4,
    [SUPPLIER_STATUS.TERMINATED]: 5,
};

// 라이더 계약 상태
export const RIDER_CONTRACT_STATUS = {
    UNDER_CONTRACT: 'UNDER_CONTRACT',
    TERMINATED_CONTRACT: 'TERMINATED_CONTRACT',
    CONTRACT_PENDING: 'CONTRACT_PENDING',
} as const;

export type RiderContractStatus = typeof RIDER_CONTRACT_STATUS[keyof typeof RIDER_CONTRACT_STATUS];

// 라이더 계약 상태 라벨 매핑
export const RIDER_CONTRACT_STATUS_LABELS: Record<RiderContractStatus, string> = {
    [RIDER_CONTRACT_STATUS.UNDER_CONTRACT]: '계약중',
    [RIDER_CONTRACT_STATUS.TERMINATED_CONTRACT]: '계약종료',
    [RIDER_CONTRACT_STATUS.CONTRACT_PENDING]: '계약대기',
};

// 협력사 운영 상태 옵션 (셀렉트박스용)
export const SUPPLIER_STATUS_OPTIONS = [
    { value: '', label: '전체' },
    { value: SUPPLIER_STATUS.OPERATING, label: SUPPLIER_STATUS_LABELS[SUPPLIER_STATUS.OPERATING] },
    { value: SUPPLIER_STATUS.TERMINATED, label: SUPPLIER_STATUS_LABELS[SUPPLIER_STATUS.TERMINATED] },
    { value: SUPPLIER_STATUS.TERMINATION_REQUESTED, label: SUPPLIER_STATUS_LABELS[SUPPLIER_STATUS.TERMINATION_REQUESTED] },
] as const;

// ============================================================
// 출금 상태
// ============================================================
export const WITHDRAWAL_STATUS = {
    ALLOWED: 'N',      // 출금 허용 (WITHDRAWAL_YN = 'N')
    RESTRICTED: 'Y',   // 출금 제한 (WITHDRAWAL_YN = 'Y')
} as const;

export type WithdrawalStatus = typeof WITHDRAWAL_STATUS[keyof typeof WITHDRAWAL_STATUS];

// 출금 상태 라벨 매핑
export const WITHDRAWAL_STATUS_LABELS: Record<WithdrawalStatus, string> = {
    [WITHDRAWAL_STATUS.ALLOWED]: '출금허용',
    [WITHDRAWAL_STATUS.RESTRICTED]: '출금제한',
};
